import React, { createContext, useContext } from 'react'
import PropTypes from 'prop-types'

/**
 * What every letterbox city plan page needs and nothing more: the plan's
 * metadata (loaded once), its counts (`stats`, refreshed on demand) and a
 * `missionsVersion` that bumps whenever a page changed missions, so tables
 * and maps refetch their own slice without the route remounting.
 */
const CityPlanContext = createContext({
  campaign: null,
  cityPlan: null,
  city: null,
  countryCode: null,
  isLetterbox: false,
  stats: null,
  statsLoading: false,
  statsError: null,
  refreshStats: () => {},
  missionsVersion: 0,
  refreshMissions: () => {},
})

export const CityPlanProvider = ({ value, children }) => (
  <CityPlanContext.Provider value={value}>{children}</CityPlanContext.Provider>
)

CityPlanProvider.propTypes = {
  value: PropTypes.object.isRequired,
  children: PropTypes.node,
}

export const useCityPlan = () => useContext(CityPlanContext)

export default CityPlanContext
